import React from 'react';
import type { SpecifiedCybersecurityOrForensicProviderFormValues } from '../CyberForensicProviderModal';
import CyberForensicProviderModal from '../CyberForensicProviderModal';
import type { RaterXModalProps } from './types';
import {
  formatProvidersForState,
  getDefaultProviderValues,
} from '../../amendatory-coverages/line-items/SpecifiedCyberOrForensicProvider';
import type { CyberForensicProviders } from '../../../../../../api/types/rater-x-preset';

const RaterXCyberForensicProviderModal = ({
  data,
  close,
}: RaterXModalProps) => {
  const onSubmit = (
    formValues: SpecifiedCybersecurityOrForensicProviderFormValues
  ) => {
    const _providers = formatProvidersForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          providers: {
            values: _providers as unknown as CyberForensicProviders[],
          },
        },
      },
    });
  };

  return (
    <CyberForensicProviderModal
      close={close}
      data={{
        onSubmit,
        defaultValues: getDefaultProviderValues(
          data.coverageState.value?.props?.providers
            ?.values as CyberForensicProviders[]
        ),
        language: data.language,
      }}
    />
  );
};

export default RaterXCyberForensicProviderModal;

export const RaterXCyberForensicProviderModalConfig = {
  RaterXCyberForensicProviderModal: {
    component: RaterXCyberForensicProviderModal,
    config: {
      title: 'Specified Cybersecurity or Forensic Provider',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
